/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const config = {};
config.sitecoreApiKey = process.env.VUE_APP_SITECORE_API_KEY || "no-api-key-set",
config.sitecoreApiHost = process.env.VUE_APP_SITECORE_API_HOST || "",
config.sitecoreSiteName = process.env.VUE_APP_SITECORE_SITE_NAME || "racqforms20",
config.layoutServiceConfigurationName = process.env.VUE_APP_LAYOUT_SERVICE_CONFIGURATION_NAME || "default",
config.defaultLanguage = process.env.VUE_APP_DEFAULT_LANGUAGE || "en",
config.graphQLEndpointPath = process.env.VUE_APP_GRAPH_QL_ENDPOINT_PATH || "/sitecore/api/graph/edge",
config.graphQLEndpoint = process.env.VUE_APP_GRAPH_QL_ENDPOINT || `${config.sitecoreApiHost}${config.graphQLEndpointPath}`;
module.exports = config;